<!-- views/Home.vue -->
<template>
  <div>
	<CookieBanner 
      :force-show="showCookieBanner" 
      @consent-saved="handleConsent" 
      @close="showCookieBanner = false" 
    />
	
    <section id="home" class="section">
      <div class="hero8-header26 thq-section-padding">
        <div class="hero8-max-width thq-section-max-width thq-flex-column">
          <div class="hero8-content">
            <div class="cssContents thq-heading-1">
              <span class="cssInlineBlock">
                {{$t('text01')}}
              </span>
            </div>
            <div class="cssContents thq-body-large">
              <span class="cssInlineBlock">
                {{$t('text02')}}
              </span>
            </div>
            <div class="hero8-actions">
              <div class="cssContents">
                <button class="cssInlineBlock thq-button-filled" @click="login">{{$t('trynow')}}</button>
              </div>
              <div class="cssContents">
                <router-link to="/contact"><button class="cssInlineBlock thq-button-outline">{{$t('requestdemo')}}</button></router-link>
              </div>
            </div>
          </div>
          <div class="">
            <img src="../assets/chatgpt image 16 apr 2025, 16_12_27-1400w.png" class="thq-img-ratio-16-9" alt="Interior design project"/>
          </div>
        </div>
      </div>
    </section>

    <section id="features" class="section">
      <div class="thq-section-padding">
        <div class="features24-container2 thq-section-max-width">
          <div class="features24-image-container">
            <img alt="feature1ImgAlt" src="../assets/vlecad_170628_lr_40_sv5_0677-1400w.jpg" v-if="activeTab === 0" class="features24-image thq-img-ratio-16-9"/>
            <img alt="feature2ImgAlt" src="../assets/vlecad_170628_lr_61_sv5_0922-1400w.jpg" v-if="activeTab === 1" class="features24-image thq-img-ratio-16-9"/>
            <img alt="feature3ImgAlt" src="../assets/vlecad_170628_lr_78_sv5_1189-1400w.jpg" v-if="activeTab === 2" class="features24-image thq-img-ratio-16-9"/>
          </div>
          <div class="features24-tabs-menu">
            <div @click="activeTab = 0" class="features24-tab-horizontal1">
              <div class="features24-divider-container1">
                <div v-if="activeTab === 0" class="features24-container3"></div>
              </div>
              <div class="features24-content">
                <h2 class="thq-heading-2">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text03')}}</span>
                  </div>
                </h2>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text04')}}</span>
                  </div>
                </span>
              </div>
            </div>
            <div @click="activeTab = 1" class="features24-tab-horizontal2">
              <div class="features24-divider-container2">
                <div v-if="activeTab === 1" class="features24-container3"></div>
              </div>
              <div class="features24-content">
                <h2 class="thq-heading-2">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text05')}}</span>
                  </div>
                </h2>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text06')}}</span>
                  </div>
                </span>
              </div>
            </div>
            <div @click="activeTab = 2" class="features24-tab-horizontal3">
              <div class="features24-divider-container3">
                <div v-if="activeTab === 2" class="features24-container3"></div>
              </div>
              <div class="features24-content">
                <h2 class="thq-heading-2">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text07')}}</span>
                  </div>
                </h2>
                <span class="thq-body-small">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text08')}}</span>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="thq-section-padding">
      <div class="thq-section-max-width">
        <div class="cta26-accent2-bg">
          <div class="cta26-accent1-bg">
            <div class="cta26-container2">
              <div class="cta26-content">
                <span class="thq-heading-2">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text09')}}</span>
                  </div>
                </span>
                <div class="thq-body-large">
                  <div class="cssContents">
                    <span class="cssInlineBlock">{{$t('text10')}}</span>
                  </div>
                </div>
              </div>
              <div class="cta26-actions">
                <button type="button" class="thq-button-filled cta26-button" @click="login">
                  <span>
                    <div class="cssContents">
                      <span class="cssInlineBlock">{{$t('text11')}}</span>
                    </div>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="thq-section-padding">
      <div class="features24-container2 thq-section-max-width">
        <div class="features24-tabs-menu">
          <div @click="activeTab2 = 0" class="features24-tab-horizontal1">
            <div class="features24-divider-container1">
              <div v-if="activeTab2 === 0" class="features24-container3"></div>
            </div>
            <div class="features24-content">
              <h2 class="thq-heading-2">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text12')}}</span>
                </div>
              </h2>
              <span class="thq-body-small">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text13')}}</span>
                </div>
              </span>
            </div>
          </div>
          <div @click="activeTab2 = 1" class="features24-tab-horizontal2">
            <div class="features24-divider-container2">
              <div v-if="activeTab2 === 1" class="features24-container3"></div>
            </div>
            <div class="features24-content">
              <h2 class="thq-heading-2">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text14')}}</span>
                </div>
              </h2>
              <span class="thq-body-small">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text15')}}</span>
                </div>
              </span>
            </div>
          </div>
          <div @click="activeTab2 = 2" class="features24-tab-horizontal3">
            <div class="features24-divider-container3">
              <div v-if="activeTab2 === 2" class="features24-container3"></div>
            </div>
            <div class="features24-content">
              <h2 class="thq-heading-2">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text16')}}</span>
                </div>
              </h2>
              <span class="thq-body-small">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text17')}}</span>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div class="features24-image-container">
          <img alt="Automatic Panel Optimization Image" src="../assets/vlecad_170628_lr_59_sv5_0915-1400w.jpg" v-if="activeTab2 === 0" class="features25-image1 thq-img-ratio-16-9">
          <img alt="Automatic Panel Optimization Image" src="../assets/vlecad_170628_lr_63_sv5_0935-1400w.jpg" v-if="activeTab2 === 1" class="features25-image1 thq-img-ratio-16-9">
          <img alt="Automatic Panel Optimization Image" src="../assets/vlecad_170628_lr_55_sv5_0896-1400w.jpg" v-if="activeTab2 === 2" class="features25-image1 thq-img-ratio-16-9">
        </div>
      </div>
    </div>

    <div class="logos1-container1 thq-section-padding logos1root-class-name">
      <div class="logos1-max-width thq-section-max-width">
        <h2 class="logos1-text1 thq-heading-2">
          <div class="cssContents">
            <span class="cssInlineBlock">{{$t('text18')}}</span>
          </div>
        </h2>
        <div class="thq-grid-6">
          <img alt="AutoFIT logo" src="../assets/scm group 2-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="AutoFIT logo" src="../assets/duivenstein-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Panel Optimization" src="../assets/schelling-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Integration with Panel Saws" src="../assets/barbaric_quality-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Warehouse Automation" src="../assets/bargstedt_logo_2010-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Material Efficiency" src="../assets/biesse-logo-articolo-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Workflow Streamlining" src="../assets/grundner-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Workflow Streamlining" src="../assets/holzher-logo-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Workflow Streamlining" src="../assets/ima schelling-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Workflow Streamlining" src="../assets/homag-1-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Workflow Streamlining" src="../assets/logo-feldergroup-1400w.png" class="logos1-logo thq-img-ratio-16-9">
          <img alt="Workflow Streamlining" src="../assets/logo-fimal-macchine-cnc-legno-1400w.png" class="logos1-logo thq-img-ratio-16-9">
        </div>
      </div>
    </div>

    <section id="pricing" class="section">
      <div id="Pricing4" class="pricing101-pricing10 thq-section-padding">
        <div class="pricing101-max-width thq-section-max-width">
          <div class="pricing101-section-title">
            <span class="cssTextAlignCenter thq-body-small">
              <div class="cssContents">
                <span class="cssInlineBlock"></span>
              </div>
            </span>
            <div class="pricing101-content1">
              <h2 class="cssTextAlignCenter thq-heading-2">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text19')}}</span>
                </div>
              </h2>
              <div class="cssTextAlignCenter thq-body-large">
                <div class="cssContents">
                  <span class="cssInlineBlock">{{$t('text20')}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="pricing101-content2">
            <a href="https://mini.autofitsoftware.com/" target="_blank" rel="noreferrer noopener" class="cssContents">
              <div class="pricing101-column1 thq-card">
                <div class="pricing101-content3">
                  <div class="pricing101-price1">
                    <div class="cssFontStyleNormal cssTextAlignCenter thq-body-large">
                      <div class="cssContents">
                        <span class="cssInlineBlock"></span>
                      </div>
                    </div>
                    <h3 class="pricing101-text14 thq-heading-3">
                      <div class="cssContents">
                        <span class="cssInlineBlock">AutoFIT mini</span>
                      </div>
                    </h3>
                    <div class="cssTextAlignCenter thq-body-large">
                      <div class="cssContents">
                        <span class="cssInlineBlock">{{$t('text21')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="pricing101-list1">
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text22')}}</span>
                        </div>
                      </span>
                    </div>
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text23')}}</span>
                        </div>
                      </span>
                    </div>
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text24')}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <button type="button" class="pricing101-button1 thq-button-outline">
                  <span class="thq-body-small">
                    <div class="cssContents">
                      <span class="cssInlineBlock">Go to mini.autofitsoftware.com</span>
                    </div>
                  </span>
                </button>
              </div>
            </a>
            <a href="/pricing" class="cssContents">
              <div class="pricing101-column2 thq-card">
                <div class="pricing101-price2">
                  <div class="pricing101-price1">
                    <div class="cssFontStyleNormal cssTextAlignCenter thq-body-large">
                      <div class="cssContents">
                        <span class="cssInlineBlock"></span>
                      </div>
                    </div>
                    <h3 class="pricing101-text14 thq-heading-3">
                      <div class="cssContents">
                        <span class="cssInlineBlock">AutoFIT Full</span>
                      </div>
                    </h3>
                    <div class="cssTextAlignCenter thq-body-large">
                      <div class="cssContents">
                        <span class="cssInlineBlock">{{$t('text25')}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="pricing101-list1">
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text26')}}</span>
                        </div>
                      </span>
                    </div>
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text27')}}</span>
                        </div>
                      </span>
                    </div>
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text28')}}</span>
                        </div>
                      </span>
                    </div>
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text29')}}</span>
                        </div>
                      </span>
                    </div>
                    <div class="pricing101-list-item">
                      <svg viewBox="0 0 1024 1024" class="thq-icon-small">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                      <span class="thq-body-small">
                        <div class="cssContents">
                          <span class="cssInlineBlock">{{$t('text30')}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <button class="pricing101-button1 thq-button-filled" @click="gotoPricing">
                  <span class="thq-body-small">
                    <div class="cssContents">
                      <span class="cssInlineBlock">{{$t('text31')}}</span>
                    </div>
                  </span>
                </button>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section id="contact" class="section">
      <div class="contact11-container thq-section-padding">
        <div class="contact11-max-width thq-section-max-width">
          <div class="contact11-section-title">
            <div class="contact11-content1">
              <h2 class="thq-heading-2">
                <div class="cssContents">
                  <span class="cssInlineBlock">
                    <span>{{$t('text32')}}</span>
                  </span>
                </div>
              </h2>
              <div class="thq-body-large">
                <div class="cssContents">
                  <span class="cssInlineBlock">
                    <span>{{$t('text33')}}</span>
                    <br/>
                    <br/>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="contact11-content2 thq-flex-row">
            <div class="contact11-content3">
              <div class="contact11-content4">
                <svg viewBox="0 0 1024 1024" class="thq-icon-medium">
                  <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
                </svg>
                <div class="pricing101-list1">
                  <h3 class="contact11-text12 thq-heading-3">Email</h3>
                  <div class="thq-body-large">
                    <div class="cssContents">
                      <span class="cssInlineBlock"></span>
                    </div>
                  </div>
                  <span class="thq-body-small">
                    <div class="cssContents">
                      <span class="cssInlineBlock"><a href="mailto:info@autofitsoftware.com">info@autofitsoftware.com</a></span>
                    </div>
                  </span>
                </div>
              </div>
              <div class="contact11-content4">
                <svg viewBox="0 0 1024 1024" class="thq-icon-medium">
                  <path d="M282 460q96 186 282 282l94-94q20-20 44-10 72 24 152 24 18 0 30 12t12 30v150q0 18-12 30t-30 12q-300 0-513-213t-213-513q0-18 12-30t30-12h150q18 0 30 12t12 30q0 80 24 152 8 26-10 44z"></path>
                </svg>
                <div class="pricing101-list1">
                  <h3 class="contact11-text12 thq-heading-3">Phone</h3>
                  <div class="thq-body-large">
                    <div class="cssContents">
                      <span class="cssInlineBlock"></span>
                    </div>
                  </div>
                  <span class="thq-body-small">
                    <div class="cssContents">
                      <span class="cssInlineBlock">+32 (0)89/81.93.30</span>
                    </div>
                  </span>
                </div>
              </div>
              <div class="contact11-content4">
                <svg viewBox="0 0 1024 1024" class="thq-icon-medium">
                  <path d="M512 0c-176.732 0-320 143.268-320 320 0 320 320 704 320 704s320-384 320-704c0-176.732-143.27-320-320-320zM512 512c-106.040 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z"></path>
                </svg>
                <div class="pricing101-list1">
                  <h3 class="contact11-text12 thq-heading-3">Office</h3>
                  <div class="thq-body-large">
                    <div class="cssContents">
                      <span class="cssInlineBlock"></span>
                    </div>
                  </div>
                  <span class="thq-body-small">
                    <div class="cssContents">
                      <span class="cssInlineBlock">VLECAD ® BV,<br/> Kanaalkom 36<br/> B-3960 Bree<br/> Belgium</span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4252.531947020754!2d5.608268377577466!3d51.15199883660321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c0c94d17a40771%3A0x9a82b860658ead70!2sVlecad!5e1!3m2!1snl!2sbe!4v1744878764568!5m2!1snl!2sbe" title="Map" class="contact11-iframe thq-img-ratio-16-9"></iframe>
          </div>
        </div>
      </div>
    </section>

    <Footer @show-cookies="openCookieSettings" />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import CookieBanner from "../components/cookiebanner.vue";

export default {
  name: 'Home',
  components: {
    Footer,
    CookieBanner
  },
  data() {
    return {
      activeTab: 0,
      activeTab2: 0,
      showCookieBanner: false
    }
  },
  methods: {
    login() {
      console.log("login");
      this.$router.push("/login");
    },
    gotoPricing() {
      this.$router.push('/pricing');
    },
    handleConsent(consent) {
      this.showCookieBanner = false;
      return consent;
    },
    openCookieSettings() {
      // Reset first so repeated clicks always retrigger the forceShow watcher.
      this.showCookieBanner = false;
      this.$nextTick(() => {
        this.showCookieBanner = true;
      });
    },
    contact() {
      console.log("contact");
      this.$router.push("/contact");
    }
  },
}
</script>

<style scoped>
.cssContents {
  display: contents;
}

.cssInlineBlock {
  display: inline-block;
}

.thq-heading-1 {
    font-size: 48px;
    font-family: STIX Two Text;
    font-weight: 700;
    line-height: 1.5;
}

.thq-body-large {
    font-size: 18px;
    font-family: Noto Sans;
    line-height: 1.5;
}

.hero8-content {
    gap: var(--dl-layout-space-oneandhalfunits);
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-item-align: stretch;
    align-self: stretch;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.hero8-actions {
    gap: var(--dl-layout-space-unit);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
}

.hero8-max-width {
  align-self: center;
}

.hero8-header26 {
  gap: var(--dl-layout-space-twounits);
}

.features24-tabs-menu {
  gap: var(--dl-layout-space-twounits);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.features24-tab-horizontal1 {
  gap: var(--dl-layout-space-twounits);
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-self: stretch;
  align-items: flex-start;
  flex-shrink: 0;
}
 
.features24-divider-container1 {
  display: flex;
  align-self: stretch;
  align-items: flex-start;
}
 
.features24-container3 {
  width: 2px;
  align-self: stretch;
  background-color: var(--dl-color-theme-neutral-dark);
}
 
.features24-content {
  gap: 16px;
  flex: 1;
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
}
 
.features24-tab-horizontal2 {
  gap: var(--dl-layout-space-twounits);
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-self: stretch;
  align-items: flex-start;
  flex-shrink: 0;
}
 
.features24-divider-container2 {
  display: flex;
  align-self: stretch;
  align-items: flex-start;
}
 
.features24-container4 {
  width: 2px;
  align-self: stretch;
  background-color: var(--dl-color-theme-neutral-dark);
}
 
.features24-tab-horizontal3 {
  gap: var(--dl-layout-space-twounits);
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-self: stretch;
  align-items: flex-start;
  flex-shrink: 0;
}
 
.features24-divider-container3 {
  display: flex;
  align-self: stretch;
  align-items: flex-start;
}
 
.features24-container5 {
  width: 2px;
  align-self: stretch;
  background-color: var(--dl-color-theme-neutral-dark);
}

.features24-container2 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-layout-space-fiveunits);
  position: relative;
  grid-template-columns: 1fr 1fr;
}
 
.features24-image-container {
  height: 100%;
  display: flex;
  position: relative;
}

.cta26-accent2-bg {
  gap: var(--dl-layout-space-oneandhalfunits);
  display: flex;
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(1deg) skew(0deg, 0deg);
  align-self: stretch;
  transition: 0.3s;
  align-items: center;
  border-radius: var(--dl-layout-radius-cardradius);
  justify-content: space-between;
  transform-style: preserve-3d;
  background-color: var(--dl-color-theme-accent2);
}
 
.cta26-accent2-bg:hover {
  transform: scale3d(1.1,1.1,1.1);
}

.cta26-accent1-bg {
  width: 100%;
  display: flex;
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-2deg) skew(0deg, 0deg);
  align-items: center;
  border-radius: var(--dl-layout-radius-cardradius);
  justify-content: space-between;
  transform-style: preserve-3d;
  background-color: var(--dl-color-theme-accent1);
}

.cta26-container2 {
  gap: var(--dl-layout-space-threeunits);
  width: 100%;
  display: flex;
  transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(1deg) skew(0deg, 0deg);
  transition: 0.3s;
  align-items: center;
  padding-top: var(--dl-layout-space-sixunits);
  padding-left: var(--dl-layout-space-fourunits);
  border-radius: var(--dl-layout-radius-cardradius);
  padding-right: var(--dl-layout-space-fourunits);
  padding-bottom: var(--dl-layout-space-sixunits);
}
 
.cta26-container2:hover {
  color: var(--dl-color-theme-neutral-light);
  background-color: var(--dl-color-theme-neutral-dark);
}

.cta26-content {
  gap: var(--dl-layout-space-oneandhalfunits);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.cta26-actions {
  gap: var(--dl-layout-space-oneandhalfunits);
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.logos1-container1 {
  gap: var(--dl-layout-space-threeunits);
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
}
 
.logos1-max-width {
  gap: var(--dl-layout-space-twounits);
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
 
.logos1-text1 {
  text-align: center;
}

.logos1-logo {
  object-fit: contain;
}

.pricing101-pricing10 {
  width: 100%;
  height: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-max-width {
  gap: var(--dl-layout-space-threeunits);
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-section-title {
  gap: var(--dl-layout-space-unit);
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  max-width: 800px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-content1 {
  gap: var(--dl-layout-space-oneandhalfunits);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-content2 {
  gap: var(--dl-layout-space-twounits);
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.pricing101-column1 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-color: var(--dl-color-theme-neutral-dark);
  border-style: solid;
  border-width: 1px;
  border-radius: var(--dl-layout-radius-radius4);
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  text-decoration: none;
}

.pricing101-content3 {
  gap: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-price1 {
  gap: var(--dl-layout-space-halfunit);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-text14 {
  font-size: 48px;
  text-align: center;
}

.pricing101-list1 {
  gap: var(--dl-layout-space-unit);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.pricing101-list-item {
  gap: var(--dl-layout-space-unit);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

.pricing101-column2 {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  border-color: var(--dl-color-theme-neutral-dark);
  border-style: solid;
  border-width: 1px;
  border-radius: var(--dl-layout-radius-radius4);
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-decoration: none;
  background-color: var(--dl-color-theme-accent1);
}

.pricing101-button1 {
  width: 100%;
}

.pricing101-price2 {
  gap: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.contact11-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.contact11-max-width {
  -ms-flex-item-align: center;
  align-self: center;
}

.contact11-section-title {
  width: 100%;
  margin-bottom: var(--dl-layout-space-threeunits);
}

.contact11-content1 {
  gap: var(--dl-layout-space-oneandhalfunits);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.contact11-content2 {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.contact11-content3 {
  gap: var(--dl-layout-space-oneandhalfunits);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.contact11-content4 {
  gap: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.contact11-text12 {
  -ms-flex-item-align: start;
  align-self: flex-start;
  text-align: center;
}

.contact11-iframe {
  height: 664px;
}

.features24-image {
  animation-name: fadeIn;
  animation-delay: 0s;
  animation-duration: 300ms;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-timing-function: ease;
}

@media(max-width: 1200px) {
  .logos1root-class-name {
    background-color: var(--dl-color-theme-accent1);
  }
}
 
@media(max-width: 767px) {
  .logos1-container1 {
    gap: var(--dl-layout-space-twounits);
  }
  .logos1-max-width {
    gap: var(--dl-layout-space-twounits);
  }
}

@media(max-width: 1200px) {
  .cta26root-class-name {
    background-color: var(--dl-color-theme-primary2);
  }
}

@media(max-width: 767px) {
  .cta26-container2 {
    gap: var(--dl-layout-space-oneandhalfunits);
    flex-direction: column;
    justify-content: flex-start;
  }
}

@media(max-width: 479px) {
  .cta26-actions {
    flex-wrap: wrap;
    align-self: stretch;
    justify-content: center;
  }
  .cta26-button {
    flex: 1;
  }
}
</style>
